export const domainName =
  import.meta.env.VITE_ENV !== "local"
    ? import.meta.env.VITE_DOMAIN_NAME
    : "localhost";
